export default __webpack_public_path__ + "static/media/flower_home.374997af.png";